import React, { Component } from "react";
import "./App.css";
import Simplify360Chat from "./Simplify360Chat/Simplify360Chat";
// import HWLogsDisplay from "./Simplify360Chat/HWLibrary/HWLogsDisplay";
import { s360ConfigService } from "./Simplify360Chat/Services/S360Config";
import { MyProvider } from "./context/Mycontext";
import {
  watchForChatSDKEvents,
  fetchConfigDetailsFromClientHost,
  checkChangeInConfig,
  loadLocalUser,
} from "./Simplify360Chat/Services/HWIframeBridge";
import HWUser from "./Simplify360Chat/HWLibrary/HWUser";
import cometdLib from "cometd";
import { cometdSubscribe } from "./cometD/cometD-service";

// initating the global CometD instance
let cometd = new cometdLib.CometD();

class App extends Component {
  constructor(props) {
    super(props);
    this.appRef = React.createRef();
    this.state = {
      user: null,
      chatMaximized: false,
    };
    
    s360ConfigService.loadClientConfigFromToken();
    if (!!s360ConfigService.config.configDetails?.restartConvWithoutReset) {
      // keep the last user data and set it again after clearing
      const lastLoginUserData = HWUser.user()
      localStorage.clear();
      if (!!lastLoginUserData)
        HWUser.updateUserDetails(lastLoginUserData, false)
    } else {
      localStorage.clear();
      s360ConfigService.loadClientConfigFromToken();
    }

    watchForChatSDKEvents(this, () => { });
  }
  componentDidMount() {
    loadLocalUser();
    fetchConfigDetailsFromClientHost();
    localStorage.removeItem("subscribed");
    checkChangeInConfig();
  }
  componentWillUnmount() {}
  configureCometd = async function (channel, cometUser, cometToken, refElement) {
    console.log(channel, refElement, "CALLED COMETD FUNCTION IN APP");

    // cometd configuration
    const host = s360ConfigService.config.host;
    let connectionURL = `https://${host}/bmcometd/cometd`;
    console.log("COMETD-LOG:CONFIGURING COMETD TO URL", connectionURL);
    cometd.websocketEnabled = true;
    cometd.configure({
      url: connectionURL.trim(),
    });

    await cometdSubscribe(
      refElement,
      channel, //client channel recieved from login
      cometUser,
      cometToken,
      cometd
    );
  };

  render() {
    //STEP 9 HERE BY NOW WE GOT CONFIG IN S360CONFIGSERVICE.JS FROM WHERE WE CAN ACCESS CONFIG FROM ALL REACT COMPONENTS
    return (
      <MyProvider cometdInstance={cometd}>
        <div ref={this.appRef} id="App">
          {/* <HWLogsDisplay/>  */}
          {/* {console.log("in APP -->",this.state)} */}
          {/* iframe code here */}
          {s360ConfigService.isConfigured() && (
            <Simplify360Chat
              user={this.state.user}
              {...this.state}
              configureCometd={this.configureCometd}
              appRef={this.appRef}
              chatMaximized={this.state.chatMaximized}
            />
          )}
        </div>
      </MyProvider>
    );
  }
}

export default App;
